import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import RepairDetails from "./sections/RepairDetails";
import BookContent from "./sections/BookContent";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <RepairDetails />
      <BookContent />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}